import React from 'react';

export default React.createContext<{ ref: React.RefObject<HTMLDivElement> }>(null!);
